/**
 * S3 Configuration
 * Update these values with your actual S3 bucket details
 */

export const S3_CONFIG = {
  BUCKET: process.env.REACT_APP_S3_BUCKET || 'your-bucket-name',
  REGION: process.env.REACT_APP_S3_REGION || 'us-east-1',
};

/**
 * CORS Configuration Note:
 * Make sure your S3 bucket has CORS enabled with the following policy:
 * 
 * [
 *   {
 *     "AllowedHeaders": ["*"],
 *     "AllowedMethods": ["GET", "HEAD"],
 *     "AllowedOrigins": ["*"],
 *     "ExposeHeaders": []
 *   }
 * ]
 */
